// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Text from "components/typography/Text";

// ** Styled Components
import { StyledModalItem } from "../styles";

// #####################################################

const ModalCountryItem = ({
	country,
	handleLocationSelect,
	close,
	alwaysLight,
	isSelected,
}) => {
	const { t } = useTranslation(["filtersAndSelectors", "countries"]);

	const { id, url } = country || {};

	// #####################################################

	return (
		<StyledModalItem
			label={id}
			onClick={() => {
				handleLocationSelect({
					country: id,
					url,
					accept: true,
					isSelected,
				});
				close();
			}}
			key={id}
			alwaysLight={alwaysLight}
			isSelected={isSelected}
		>
			<div>
				<Text color="grey" mr={1}>
					{t("filtersAndSelectors:countryLabel")}:
				</Text>
				{t(`countries:${id}`)}
			</div>
		</StyledModalItem>
	);
};

export default ModalCountryItem;

// #####################################################
